import { NodeSubType } from "../../models/nodeSubType";
import { FallbackState } from "../fallback-response";
import { MessageTemplateButton } from "../../models/blockEdit";

export enum ASSISTANT_QRB {
  TALK_TO_AGENT = "talkToAgent",
  MAIN_MENU = "mainMenu",
}

export const ASSISTANT_QRB_CARDS = [
  {
    id: ASSISTANT_QRB.TALK_TO_AGENT,
    label: "Talk to agent",
  },
  {
    id: ASSISTANT_QRB.MAIN_MENU,
    label: "Main menu",
  },
];

// Instagram-only product action buttons
export enum INSTAGRAM_PRODUCT_ACTION {
  BUY_NOW = "buyNow",
  PRODUCT_INFO = "productInfo",
  VIEW_PRODUCT = "viewProduct",
}

export const INSTAGRAM_PRODUCT_ACTION_CARDS = [
  {
    id: INSTAGRAM_PRODUCT_ACTION.BUY_NOW,
    label: "Buy now",
  },
  {
    id: INSTAGRAM_PRODUCT_ACTION.PRODUCT_INFO,
    label: "Product Info",
  },
  {
    id: INSTAGRAM_PRODUCT_ACTION.VIEW_PRODUCT,
    label: "View product",
  },
];

export enum AnalyticsEvent {
  PurchaseClick = "buy_now",
  ViewClick = "view_product",
  InfoClick = "product_info",
}

export const buttonIdToActionId: Record<string, string> = {
  buy_now: "buyNow",
  view_product: "viewProduct",
  product_info: "productInfo",
};

export type AiAssistantI = {
  id: string;
  name: string;
  type: AiAssistantType;
  is_draft: boolean;
};

export enum AiAssistantType {
  FAQ = "FAQ",
  PRODUCT_SEARCH = "Product Search",
  GENERAL_PURPOSE = "General Purpose",
}

export type AutoCloseConfig = {
  auto_close_enabled: boolean;
  auto_close_duration: number | null; // in minutes
};

export enum ProductAction {
  BUY_NOW = "buy_now",
  PRODUCT_URL = "product_url",  
}

export type AiAssistantBackendConfig = {
  type: string;
  sub_type: NodeSubType;
  node_index: number;
  custom_prompt?: string;
  assistant_config?: BikAiAssistantConfig;
  fallback?: FallbackState;
  buttons_list?: MessageTemplateButton[];
  conditions: {
    operator: "goto";
    operator_values: { [key: string]: { key: string; value: string } };
  }[];
  error_flow_config?: ErrorFlowConfig | null; // fallback flow
  auto_close_config?: AutoCloseConfig;
};

export type ErrorFlowConfig = {
  error_node_id: string;
}

export type AiAssistantFrontendConfig = {
  type: string;
  subType: NodeSubType;
  isMicroFlow: boolean;
  description: string;
  slang: string;
  childNodes: { [key: string]: { key: string; value: string } };
};

export type BikAiAssistantFunctions = {
  name: string; // GPTFunctionType
  params?: Record<string, any>;
};

export enum BikAiAssistantPromptType {
  GENERAL_PURPOSE_ASSISTANT = "general_purpose_assistant",
  ORDER_TRACKING = "order_tracking",
}

export type BikAiAssistantConfig = {
  data_sources: any[]; // Replace any with actual BikAiAssistantDataSource type if available
  functions: BikAiAssistantFunctions[];
  prompt_type: BikAiAssistantPromptType;
  output_message_format?: string;
};
